import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=1ca1e6a0&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=js"
export * from "./SingleOrder.vue?vue&type=script&lang=js"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&id=1ca1e6a0&prod&lang=scss&scoped=true"
import style1 from "./SingleOrder.vue?vue&type=style&index=1&id=1ca1e6a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1e6a0",
  null
  
)

export default component.exports